export class Stars {

    constructor(physics, numberOfStars=5) {
        let stars = physics.add.group({
            key: 'star',
            repeat: numberOfStars-1,
            setXY: { x: 12, y: 0, stepX: 70 }
        });

        stars.children.iterate(function (child) {

            //  Give each star a slightly different bounce
            child.setBounceY(Phaser.Math.FloatBetween(0.4, 0.8));

        });
        this.stars = stars;
    }
    
    areAllCollected() {
        return this.stars.countActive(true) === 0;
    }

    newBatchOfStarsToCollect() {
        this.stars.children.iterate(function (child) {

            child.enableBody(true, child.x, 0, true, true);

        });
    }

    img() {
        return this.stars;
    }
}